import { Card, LinearProgress, Stack } from '@mui/material';
import React from 'react';
import { selectedTurnItem } from '../../../shared/selected.turn.items';
import { useAtom } from 'jotai';
import { selectedDoctorAtom } from '../../../shared/selected.doctor';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { selectedTurnBase } from 'Routes/Public/GetNewTurn/shared/selected.turn.base';
import {
  AccountCircle,
  Apartment,
} from '@mui/icons-material';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { selectedSpecialityServiceAtom } from 'Routes/Public/GetNewTurn/shared/selected.speciality.service';
import FrameCard from 'Global/Components/CommonComponents/FrameCard/FrameCard';
import { seletedDepartmentId } from 'Routes/Public/GetNewTurn/shared/selected.department.ids';

const TurnInfo = ({ turnBaseData }) => {
  const [selectedDoctor] = useAtom(selectedDoctorAtom);
  const [turnItem] = useAtom(selectedTurnItem);
  const [turnBase] = useAtom(selectedTurnBase);
  const [selectedSpecialityService] = useAtom(
    selectedSpecialityServiceAtom
  );
  const [departmentIds] = useAtom(seletedDepartmentId);

  // console.log('selectedDoctor->', {
  //   selectedDoctor,
  //   departmentIds,
  // });

  // console.log(
  //   'selectedSpecialityService->',
  //   selectedSpecialityService
  // );

  // console.log('Turn info Lunar =>', {
  //   selectedDoctor,
  //   turnItem,
  //   turnBase,
  //   selectedSpecialityService,
  //   departmentIds,
  // });

  return (
    <React.Fragment>
      <FrameCard
        cardProps={{ p: '.3em', borderRadius: '20px' }}
        jsx={
          <Stack
            alignItems={
              selectedDoctor ? 'center' : 'initial'
            }
            gap=".5em"
            sx={{
              backgroundColor: 'white',
              p: '.3em',
              borderRadius: '20px',
            }}
          >
            {!selectedDoctor ? (
              <LinearProgress />
            ) : (
              <>
                {selectedDoctor?.doctor
                  ?.imageArrayContent ? (
                  selectedDoctor?.doctor?.imageArrayContent
                    ?.image ? (
                    <img
                      src={`data:image/png;base64,${selectedDoctor?.doctor?.imageArrayContent?.image}`}
                      loading="..."
                      width={70}
                      height={70}
                      style={{ borderRadius: '100%' }}
                    />
                  ) : (
                    <AccountCircle
                      sx={{
                        width: '3em',
                        height: '3em',
                        color: themeColors.ColorPrimary,
                      }}
                    />
                  )
                ) : (
                  <Apartment
                    sx={{
                      fontSize: '2.5em',
                      color: themeColors.ColorPrimary,
                    }}
                  />
                )}
                {!departmentIds ? (
                  <p>
                    {ArabicToPersian(
                      selectedDoctor?.doctor?.nameDoctor
                    )}
                     
                    {ArabicToPersian(
                      selectedDoctor?.doctor?.familyDoctor
                    )}
                  </p>
                ) : (
                  <></>
                )}

                <p>
                  {ArabicToPersian(
                    selectedDoctor?.doctor?.speciality?.Name
                  )}
                </p>
                {departmentIds ? (
                  ArabicToPersian(selectedDoctor?.Name)
                ) : (
                  <></>
                )}
                {turnBase !== 'speciality' ? (
                  <p>{ArabicToPersian(turnItem?.label)}</p>
                ) : (
                  <p>
                    {ArabicToPersian(
                      selectedSpecialityService?.label
                    )}
                  </p>
                )}
              </>
            )}
          </Stack>
        }
      />
    </React.Fragment>
  );
};

export default TurnInfo;
